import React, { CSSProperties } from 'react';
import { useIntl } from 'umi';
import classnames from 'classnames';
import Abnormal from '@/pages/intelligence/components/Abnormal';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import StoreRanksTopCommcardList from '@/pages/intelligence/pages/StoreRanks/components/StoreRanksTopCommcardList';

import type { IBaseProps } from '@/pages/intelligence/types/common';
import type { IStoreRankTop, IStoreRankTopRank } from '@/pages/intelligence/types/storeRank';

interface IStoreRankTopCoreProps extends IBaseProps {
  entityType: 'mobile' | 'pc' | 'console' | 'minigame';
  gameIdKey: string;
  isLoading: boolean;
  loadingContentStyle?: CSSProperties;
  tops: IStoreRankTop[];
  filter?: React.ReactElement;
  exportTable?: React.ReactElement;
  showDownloadTips?: boolean;
  // 筛选器与下载按钮是否同行（下载按钮保持最右侧），仅 PC/Console 榜单页使用
  inlineDownload?: boolean;
  // 榜单的无游戏rank数据UI renderer
  noDataRenderer?: (payload: { source: string; lastDate: string }) => React.ReactElement;
  onCardTitleClick?: (top: IStoreRankTop) => void;
  onCardGameClick?: (top: IStoreRankTop, topRank: IStoreRankTopRank, isValidGameId: boolean) => void;
  getDetailGamePath?: (top: IStoreRankTop, topRank: IStoreRankTopRank, isValidGameId: boolean) => string;
}

const StoreRankTopCore: React.FC<IStoreRankTopCoreProps> = (props) => {
  const {
    style,
    loadingContentStyle,
    className,
    entityType,
    gameIdKey,
    isLoading,
    tops,
    filter,
    exportTable,
    showDownloadTips = false,
    inlineDownload = false,
    noDataRenderer,
    onCardTitleClick,
    onCardGameClick,
    getDetailGamePath,
    isShowMarketIcon = true,
  } = props;

  const { formatMessage } = useIntl();

  return (
    <div style={style} className={classnames('dbi-store-rank-top-core', className)}>
      {/* 筛选器 */}
      {inlineDownload ? (
        <div className="dbi-store-rank-top-core__filter-download">
          {React.isValidElement(filter) && filter}
          {React.isValidElement(exportTable) && (
            <div className="dbi-store-rank-top-core__download-area">
              {showDownloadTips ? (
                <span className="dbi-store-rank-top-core__download-tips">
                  {formatMessage({ id: 'dbi_store_rank_download_tips_title' })}
                </span>
              ) : null}
              {exportTable}
            </div>
          )}
        </div>
      ) : (
        <>
          {React.isValidElement(filter) && filter}
          {React.isValidElement(exportTable) && (
            <div className="dbi-store-rank-top-core__download-area">
              {showDownloadTips ? (
                <span className="dbi-store-rank-top-core__download-tips">
                  {formatMessage({ id: 'dbi_store_rank_download_tips_title' })}
                </span>
              ) : null}
              {exportTable}
            </div>
          )}
        </>
      )}
      {isLoading && (
        <CardSlotV2 isNoBg style={{ marginTop: 10, backgroundColor: 'transparent' }}>
          <Abnormal
            isLoading={true}
            isNoData={false}
            component={<></>}
            style={loadingContentStyle}
          />
        </CardSlotV2>
      )}
      {!isLoading && !tops?.length && (
        <CardSlotV2 style={{ marginTop: 10 }}>
          <Abnormal isLoading={false} isNoData={true} component={<></>} />
        </CardSlotV2>
      )}
      {!isLoading && tops?.length > 0 && (
        <StoreRanksTopCommcardList
          entityType={entityType}
          gameIdKey={gameIdKey}
          tops={tops}
          noDataRenderer={noDataRenderer}
          onCardTitleClick={onCardTitleClick}
          onCardGameClick={onCardGameClick}
          getDetailGamePath={getDetailGamePath}
          isShowMarketIcon={isShowMarketIcon}
        />
      )}
    </div>
  );
};

export default StoreRankTopCore;
